import { ReactElement } from 'react';

import { Checkbox } from '@dreryk/react-components';
import { BindingCreator } from '@dreryk/react-common';

import { settingsTranslationKeys } from '../../../../translations';
import { AppointmentRequestsSettingsFormController } from '../AppointmentRequestsSettingsForm.types';

import { StyledBlockShortAdvanceBookingField } from './BlockShortAdvanceBookingField.styled';
import { SlotBookingLeadPeriodInHoursField } from './SlotBookingLeadPeriodInHoursField';

type BlockShortAdvanceBookingFormBeanPart = {
   blockShortAdvanceBooking: boolean;
   slotBookingLeadPeriodInHours: number | null;
};

type BlockShortAdvanceBookingFieldProps = {
   register: BindingCreator<BlockShortAdvanceBookingFormBeanPart>;
   watch: AppointmentRequestsSettingsFormController['watch'];
};

export const BlockShortAdvanceBookingField = (props: BlockShortAdvanceBookingFieldProps): ReactElement => {
   const currentBlockShortAdvanceBooking = props.watch('blockShortAdvanceBooking');
   return (
      <StyledBlockShortAdvanceBookingField direction={'column'} gap={'12px'}>
         <Checkbox
            testId={'blockShortAdvanceBooking'}
            controller={props.register('blockShortAdvanceBooking')}
            label={settingsTranslationKeys.blockShortAdvanceBooking}
         />
         {currentBlockShortAdvanceBooking ? <SlotBookingLeadPeriodInHoursField register={props.register} /> : null}
      </StyledBlockShortAdvanceBookingField>
   );
};
